import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Zap } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function MechanismSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full px-6 py-10 bg-gradient-to-b from-dark-navy via-muted-teal/5 to-dark-navy" data-id="element-113">
      <div className="max-w-3xl mx-auto" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-115">
          <img src="https://cdn.magicpatterns.com/uploads/iYMK65cUDt9mw7PPT3HwWD/Gemini_Generated_Image_z2nj4az2nj4az2nj_(1).png" alt="Diagrama del Nervio Vago — modo alarma vs modo calma" className="w-full max-w-2xl mx-auto rounded-xl mb-8" data-id="element-116" />

          <div className="flex items-center gap-4 mb-8" data-id="element-117">
            <Zap className="w-8 h-8 text-muted-teal" strokeWidth={1.5} data-id="element-118" />
            <h2 className="font-playfair text-3xl md:text-4xl font-bold text-muted-teal" data-id="element-119">
              Hay un interruptor. Se llama Nervio Vago.
            </h2>
          </div>

          <p className="text-lg md:text-xl mb-6" data-id="element-120">
            Tu sistema nervioso tiene un modo "alarma" y un modo "calma". El
            nervio vago es el cable que conecta los dos.
          </p>

          <p className="text-lg md:text-xl mb-6" data-id="element-121">
            Cuando tu vida moderna — las pantallas, el estrés laboral, las
            noticias, las notificaciones, el ruido constante — activa el modo
            alarma de forma crónica, el nervio vago pierde tono. Tu cerebro deja
            de recibir la señal de que estás a salvo. Y sin esa señal, no puede
            relajarse. Por mucho que quieras.
          </p>

          <p className="text-lg md:text-xl mb-6" data-id="element-122">
            La buena noticia es que ese cable se puede reactivar. Se puede
            entrenar.
          </p>

          <p className="text-lg md:text-xl font-medium text-muted-teal" data-id="element-123">
            Y cuando lo haces — a través de respiración específica, movimiento
            somático, señales de entorno y técnicas de descarga cognitiva — tu
            sistema nervioso recibe la orden biológica de salir del modo alarma.
          </p>

          <p className="text-2xl md:text-3xl font-playfair font-bold text-amber-gold mt-8" data-id="element-124">
            No en semanas. En minutos.
          </p>

          <CtaButton text="Quiero resetear mi sistema nervioso esta noche" subtitle="Acceso inmediato al kit completo" data-id="element-125" />
        </motion.div>
      </div>
    </section>;
}